// import React from "react"
import { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";

import { Link, useNavigate } from "react-router-dom";

import Pagination from '@mui/material/Pagination';

import authAxios from "../../components/authAxios";

import AddIcon from '@mui/icons-material/Add';
import { Fab } from "@mui/material";
import { VisibilityOutlined } from "@mui/icons-material";
// import PrintIcon from '@mui/icons-material/Print';
import { PrintSharp } from "@mui/icons-material";

import { useMediaQuery } from 'react-responsive'

import { format } from 'date-fns';
// import ThreeDotsMenu from "../../components/ThreeDotsMenu";
import EllipsisMenu from "../../components/EllipsisMenu";


const TransactionList = ({module, transactions, order, handlePageChange, page, pagecount, setIsModalOpen}) => {
    // const isMobile = useMediaQuery({ query: '(max-width: 750px)' })
    const navigate = useNavigate()
    const [showAccount, setShowAccount] = useState(true)
    const [showDescription, setShowDescription] = useState(false)
    const [showQuantity, setShowQuantity] = useState(false)

    const { data: clientProfile } = useQuery({
        queryKey: ['clientProfile'],
        queryFn: async () => {
          const response = await authAxios.get(`/clientprofiles/${localStorage.getItem('clientProfile')}`);
          return response.data

        },
    });

    const menuItems = (transaction) => {
        const baseItems = []

        let txn_id = transaction.id
        if (module !== 'ACC') {
            txn_id = transaction.transaction
        }
        baseItems.push({
            label: 'View',
            icon: <VisibilityOutlined />,
            onClick: () => {
                navigate(`/dashboard/transaction/${txn_id}`);
            }
        });

        // console.log("TRANSACTION", transaction)

        if (transaction.type_code === "020") {

            baseItems.push({
                label: 'Print',
                icon: <PrintSharp />,
                onClick: () => {
                                // navigate(`/dashboard/transaction/${txn_id}`);
                    navigate(`/dashboard/receipt-document/`, {state: {transactionId: txn_id}});
                }
            });
        }

        return baseItems;
    };

    const convertDateTime = (myDateTime) => {
        return format(new Date(myDateTime), 'dd-MM-yyyy HH:mm');
    };
    
 
    useEffect(()=>{
        if (module!=="ACC" && module!=="PMS") {
            setShowAccount(false)
            setShowDescription(true)
        }
        
        if (module==="PMS") {
            setShowDescription(true)
        }

        if (module==="INV" ) {
            setShowQuantity(true)
        }
     },[module])


    return (
        <>
            <table className="styled-table">
                <thead>
                    <tr >
                        <th>Reference</th>
                        <th>Date</th>
                        <th>Type</th>
                        {showAccount && 
                            <th>Account</th>
                        }
                        {showDescription && 
                            <th>Description</th>
                        }
                        {showQuantity && 
                            <th>Quantity</th>
                        }
                        <th className="cell-align-right">Amount</th>
                        <th>DR/CR</th>
                        <th></th>
                    </tr>
                </thead>

                {transactions && transactions.map(transaction => (
                    <tbody key={transaction.id}>
                        <tr>
                            <td>{transaction.reference}</td>
                            <td>{convertDateTime(transaction.date)}</td>

                            <td>{transaction.trans_type}</td>
                            {showAccount &&
                                <td>{transaction.account_name}</td>
                            }
                            {showDescription &&
                                <td>{transaction.description}</td>
                            }
                            {showQuantity &&
                                <td>{transaction.quantity}</td>
                            }
                            {clientProfile && clientProfile.currency_code? 
                                <td className="cell-align-right">{Number(transaction.amount).toLocaleString('en-UK', { style: 'currency', currency: clientProfile.currency_code })}</td>
                                :
                                <td>{Number(transaction.amount).toLocaleString('en-UK')}</td>
                            }

                            <td>{transaction.entry_type}</td>
                            <td className='styled-table-menu'>
                                <EllipsisMenu items={menuItems(transaction)} />
                            </td>
                        </tr>
                    </tbody>
                ))}
            </table>


            <Pagination 
                className="custom-mui-pagination"
                count={pagecount} 
                page={page} 
                onChange={handlePageChange} 
            />
            {(module==="ACC") &&
                <Link to="/dashboard/transactionnew" state={{module: module, order:order}} className="nav-link">
                    <Fab className="fab" color="primary" aria-label="add">
                        <AddIcon />
                    </Fab>
                </Link>
            }
        </>
    );
  };
  
export default TransactionList;